// Static constants used across tracking events
// ----------------------------------------------------------------
export const DEFAULT_NEWSLETTER_ON_REGISTRATION = 'NSNEW';
export const EVENT_NEW_REGISTRATION = 'new_registration';
export const EVENT_NEWSLETTER_SIGNUP = 'newsletter_signup';
export const EVENT_TYPE_NEWSLETTER_SIGNUP = 'newsletter signup';
export const EVENT_ACTION_SUBSCRIBED = 'subscribed';
export const EVENT_ACTION_UNSUBSCRIBED = 'unsubscribed';
export const EVENT_ACTION_UPDATED = 'updated';
export const EVENT_TYPE_NEW_REGISTRATION_FLOW = 'new registration flow';
export const EVENT_TYPE_DIRECT = 'direct';
export const EVENT_TYPE_BROWSING_STOP = 'browsing stop';
export const EVENT_SUBTYPE_REGWALL = 'regwall';
export const EVENT_DETAILS_ADDITION = 'addition';
export const EVENT_DETAILS_REMOVAL = 'removal';
export const SERVICE_PLATFORM_NATIVE = 'native';
export const SERVICE_PLATFORM_PIANO = 'piano';

// Keys used in the newsletter sign-up dataLayer object
// ----------------------------------------------------------------
export const NEWSLETTER_SIGNUP_KEY_EVENT_TYPE = `event_type_${EVENT_NEWSLETTER_SIGNUP}`;
export const NEWSLETTER_SIGNUP_KEY_SUB_TYPE = `event_subtype_${EVENT_NEWSLETTER_SIGNUP}`;
export const NEWSLETTER_SIGNUP_KEY_SERVICE_PLATFORM = `service_platform_${EVENT_NEWSLETTER_SIGNUP}`;
export const NEWSLETTER_SIGNUP_KEY_EVENT_DETAILS = `event_details_${EVENT_NEWSLETTER_SIGNUP}`;
export const NEWSLETTER_SIGNUP_KEY_EVENT_ACTION = `event_action_${EVENT_NEWSLETTER_SIGNUP}`;
export const NEWSLETTER_SIGNUP_KEY_OBJECT_NAME = `event_object_name_${EVENT_NEWSLETTER_SIGNUP}`;
export const NEWSLETTER_SIGNUP_KEY_EVENT_VALUE = `event_value_${EVENT_NEWSLETTER_SIGNUP}`;

// Keys used in the new registration dataLayer object
// ----------------------------------------------------------------
export const NEWSLETTER_REGISTRATION_KEY_EVENT_TYPE = `event_type_${EVENT_NEW_REGISTRATION}`;
export const NEWSLETTER_REGISTRATION_KEY_SUB_TYPE = `event_subtype_${EVENT_NEW_REGISTRATION}`;
export const NEWSLETTER_REGISTRATION_KEY_SERVICE_PLATFORM = `service_platform_${EVENT_NEW_REGISTRATION}`;
export const NEWSLETTER_REGISTRATION_KEY_EVENT_DETAILS = `event_details_${EVENT_NEW_REGISTRATION}`;

// URL parameter used to distinguish form names in marketing context
export const URL_PARAMETER_FORM_NAME = 'form_name';
